import { country } from 'utils/settings';

function initDualCurrency() {
    if (country === 'hr' && window.ikea.dualCurrency === undefined) {
        import('./dualCurrencyBundle').then(dualCurrency => (window.ikea.dualCurrency = dualCurrency));
    }
}

export default initDualCurrency;
